angular.module('files')
    .service('FileUploadFoldersService', function (modals) {
        this.uploadModal = params => modals.open('app/files/file-upload-folders-modal.html', 'FileUploadFoldersCtrl', params, {size: 'lg'})
    })
    .controller('FileUploadFoldersCtrl', function ($scope, $rootScope, $uibModalInstance, data, toastr, Folder, FileUploaderLocal, FolderService) {
        $scope.folderTree = data != null ? data.folderTree || {} : {};
        $scope.folders = data != null ? data.folders || [] : [];
        $scope.initialSelection = data != null ? data.initialSelection || {} : {};
        $scope.uploadFormData = {
            isLinkActive: true,
            isAssignable: false
        };
        $scope.onFolderSelect = onFolderSelect;
        onFolderSelect($scope.initialSelection);

        let close = () => $uibModalInstance.dismiss('Canceled');

        function onFolderSelect(folder) {
            if (folder != null && angular.isDefined(folder.id)) {
                $scope.uploadFormData.folder = folder.id;

            } else {
                delete $scope.uploadFormData.folder;
            }
        }

        function formDataFn() {
            return $scope.uploadFormData;
        }

        $scope.uploader = FileUploaderLocal.create(formDataFn, close);

        if (data?.selected != null) {
            $scope.selectedFolder = data.selected;
            $scope.uploadFormData.folder = data.selected.id;
        }

        if ($scope.folders.length === 0) {
            $scope.folders = [{id: null, name: ".."}];
            Folder.query(function (folders) {
                $scope.folders = $scope.folders.concat(folders);
                FolderService.formatFolders($scope.folders);
            });
        }

        $scope.cancel = () => close();
    });
